import React, { Component } from "react";
import Profile from "../../components/Profile";

export default class Team2025 extends Component {
  render() {
    return (
      <div>
        <div className="row mb-5">
          <div className="col-lg text-center">
            <h1> Meet the Team! </h1>
          </div>
        </div>

        {/* Leadership */}
        <div className="row mb-5 mr-2 ml-2">
          <div className="row">
            <Profile
              image="leads-2025-2026/naveen.jpg"
              memberName="Naveen Black"
              role="Team Co-Captain"
              discipline="CIV2T6 + PEY"
              linkedin="https://www.linkedin.com/in/naveen-black/"
              blurb="Naveen sees Seismic as a great way to apply theoretical engineering concepts in a hands-on environment. He enjoys the opportunity to interact and collaborate with other like-minded students from a variety of disciplines, and genuinely enjoys the work they do—especially physically building the tower and coordinating the whole team. He's excited to have the chance to lead such a large and diverse group of people and navigate all the challenges that entails. Currently a structural PEY student at RJC, Naveen grew up around the world (California, Vietnam, South Africa, Jordan, Bosnia, New York, Toronto) and enjoys reading, baking, Lego, chocolate, and being lazy."
            />
            <Profile
              image="leads-2025-2026/kevin-xu.jpg"
              memberName="Kevin Xu"
              role="Team Co-Captain"
              discipline="CIV2T6 + PEY"
              linkedin="https://www.linkedin.com/in/kevin-xu-741816259/"
              blurb="Kevin joined to learn more about the administrative side of the team and help improve communication between all subteams. He's excited to contribute to the team's operations and ensure everything runs smoothly. He enjoys solving Rubik's Cubes and playing basketball in his free time."
            />
          </div>
        </div>

        {/* Architecture */}
        <div className="row mb-5 mr-2 ml-2">
          <h2 className="big-font text-dark mb-5"> Architecture </h2>
          <div className="row">
            <Profile
              image="leads-2025-2026/javine.jpg"
              memberName="Javine Matthews-Gilford"
              role="Architecture Specialist"
              discipline="ARC2T7"
              linkedin=""
              blurb="Javine joined the seismic design team because it aligns with her passions for woodworking, structures and model making. She is interested in applying her background as an architecture student in a practical setting to learn more about the construction process while interacting with others who are also interested in this field. Javine enjoys baking and cake decorating in her free time."
            />
            <Profile
              image="leads-2025-2026/janice.jpg"
              memberName="Janice Lau"
              role="Architecture Specialist"
              discipline="ARC2T8"
              linkedin="https://www.linkedin.com/in/janice-lau-8b3494330"
              blurb="Janice is interested in collaboration between engineering and architecture. She's excited to take this as a learning opportunity to gain more confidence in doing new things and strengthen skills across the board including but not limited to research and design, while broadening learning horizons and pursuing her interest and curiosity in seismic design. Aside from school and work, she enjoys going to the gym on her free time, changing her hair colour whenever she is bored, and cooking and baking recipes she finds."
            />
            <Profile
              image="leads-2025-2026/celine.jpg"
              memberName="Celine Alrefai"
              role="Architecture Specialist"
              discipline="ARC2T6"
              linkedin="https://www.linkedin.com/in/celinealrefai/"
              blurb="Celine is interested in how architecture and engineering intersect. She wants to gain hands-on experience in structural design and is passionate about resilient, sustainable buildings. She's looking to collaborate with a multidisciplinary team and is excited to apply design skills to real-world challenges. She enjoys reading, going to the gym and will drink coffee at any possible moment."
            />
            <Profile
              image="leads-2025-2026/kala.jpg"
              memberName="Kala Kamani"
              role="Architecture Specialist"
              discipline="ARC2T7"
              linkedin="https://www.linkedin.com/in/kala-kamani-72611b318"
              blurb="Kala is interested in exploring the practical and structural aspect of design in construction, working as a team and learning about the engineering process. She hopes to challenge her knowledge and abilities specifically in terms of software programs. She enjoys going on long distance bike rides and looks forward to joining the Seismic design team this year!"
            />
            <Profile
              image="leads-2025-2026/madison.jpg"
              memberName="Madison Munro"
              role="Architecture Specialist"
              discipline="ARC2T7"
              linkedin="https://www.linkedin.com/in/madison-munro"
              blurb="Madison really enjoyed her time on the team last year and sees UTSD as a creative outlet that allows her to keep developing her design skillset outside of the classroom. It's a chance to keep learning, experimenting and designing alongside a multidisciplinary team. Between Rhino crashes, corrupted files and questionable amounts of caffeine, UTSD has been pivotal for character development."
            />
          </div>
        </div>

        {/* Design and Analysis */}
        <div className="row mb-5 mr-2 ml-2">
          <h2 className="big-font text-dark mb-5"> Design and Analysis Specialists </h2>
          <div className="row">
            <Profile
              image="leads-2025-2026/harry.jpeg"
              memberName="Harry Chen"
              role="Senior Design and Analysis Specialist"
              discipline="CIV2T6 + PEY"
              linkedin="http://linkedin.com/in/harry-chen3504"
              blurb="Harry wanted to learn how to work and lead in a big team environment and learn more about structural engineering. He has experience testing towers under GM3 and brings a practical mindset to every challenge."
            />
            <Profile
              image="leads-2025-2026/mustafa.png"
              memberName="Mustafa Nasir"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T6 + PEY"
              linkedin="https://www.linkedin.com/in/mustafa-nasir-380352207"
              blurb="Mustafa is really into structural engineering, and earthquake engineering has always caught his attention. The idea of designing buildings to handle seismic forces is a challenge he'd like to take on. He thinks joining the Seismic Design Team is a great way to apply what he's learned so far, gain hands-on experience, and keep learning. He's also looking forward to meeting new people who are passionate about the same things and working together on something meaningful. He loves playing and watching sports: basketball, cricket, football (soccer), and going to the gym."
            />
            <Profile
              image="leads-2025-2026/kiarash.jpg"
              memberName="Kiarash Seiedi"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T7 + PEY"
              linkedin=""
              blurb="Kia has always been fascinated by how buildings are made, ever since playing with Legos when he was a kid. He hopes to learn more about the methods and design principles that are used to keep these structures standing, and looks forward to learning and working with fellow members of the UTSD team! Kia enjoys playing soccer, guitar, and making different types of eggs."
            />
            <Profile
              image="leads-2025-2026/vanik.jpg"
              memberName="Vanik Park"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T7 + PEY"
              linkedin="https://www.linkedin.com/in/vanikpark"
              blurb="Seismic is a place where Vanik can interact and work with like-minded individuals. It's an environment of professional development, but also a great change of pace from the university lifestyle. Between building, designing, and discussing with the team, Seismic is a place of retreat and lots of fun; you get to meet and work with great people and make great connections, both in friendships and in industry. Alongside other members and executives, Seismic endeavours to teach and encourage engineers and architects to learn new skills, develop teamwork and leadership, and innovate for real-world applications. He obtained his Private Pilot License through the Air Cadet Program and enjoys reading and writing stories."
            />
            <Profile
              image="leads-2025-2026/sami.png"
              memberName="Sami Ahmed"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T8 + PEY"
              linkedin="https://www.linkedin.com/in/sami-ahmed-90881b326/"
              blurb="Sami is interested in seismic and structural engineering. He finds it a great way to connect, befriend and network with fellow civil engineering students. He finds it very relaxing to just assemble floors, braces, columns, etc, especially after a long day of classes. He loves weightlifting, his favourite artist is Kanye West, and his favourite movie is Raiders of the Lost Ark."
            />
            <Profile
              image="leads-2025-2026/maya.jpeg"
              memberName="Maya Richman"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T8 + PEY"
              linkedin="https://www.linkedin.com/in/maya-richman-217997347/"
              blurb="Maya is interested in structural design, earthquake engineering, and modelling software. She completed a co-op in building science, was a competitive swimmer for 8 years, and loves to read and sleep."
            />
            <Profile
              image="leads-2025-2026/kevin-huang.jpeg"
              memberName="Kevin Huang"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T6 + PEY"
              linkedin=""
              blurb="Kevin is interested in structural engineering and seismic design as a future career path. He wants to apply classroom knowledge (e.g., solid mechanics, structural analysis) to a hands-on project and is excited to learn modeling tools like SAP2000 and improve technical skills. He enjoys collaborative, team-based environments and is looking for a challenge that involves both design and problem-solving. He's curious about how structures behave under dynamic loads like earthquakes and wants to gain experience relevant for co-op and industry opportunities. He finds calm in routine but still enjoys trying new things, especially when it comes to food or travel. He tends to overpack for trips—especially if he thinks there's a chance to take cool photos."
            />
            <Profile
              image="leads-2025-2026/tahmid.jpeg"
              memberName="Tahmid Rahman"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T7 + PEY"
              linkedin="https://www.linkedin.com/in/tahmidrahman-/"
              blurb="Tahmid joined UTSD for the chance to use industry level programs such as SAP2000 in a fun team environment. Structural engineering is something he wants to pursue in the future. He enjoys playing video games and weightlifting in his free time, and unlike most people, he enjoys school."
            />
            <Profile
              image="leads-2025-2026/banseok.jpg"
              memberName="Banseok Kim"
              role="Junior Design and Analysis Specialist"
              discipline="CIV2T7 + PEY"
              linkedin=""
              blurb="Banseok sees this as an opportunity to improve his technical design skills in a collaborative environment and wants to gain structural and geotechnical knowledge. He translated for a U.S. Army training exercise while serving in the military in Korea."
            />
          </div>
        </div>

        {/* Construction */}
        <div className="row mb-5 mr-2 ml-2">
          <h2 className="big-font text-dark mb-5"> Construction Managers </h2>
          <div className="row">
            <Profile
              image="leads-2025-2026/brian.jpg"
              memberName="Brian Tobing"
              role="Construction Manager"
              discipline="CIV2T7 + PEY"
              linkedin="https://www.linkedin.com/in/brian-tobing/"
              blurb="Brian is interested in structural engineering with a mix of project management and wants to meet and work alongside motivated people. He is from Hong Kong and speaks 3 languages."
            />
            <Profile
              image="leads-2025-2026/nivin.jpeg"
              memberName="Nivin Khan"
              role="Construction Manager"
              discipline="CIV2T7 + PEY"
              linkedin="https://www.linkedin.com/in/nivin-khan"
              blurb="Nivin originally joined last year because she aims to have a career in structural engineering and Seismic helps to prepare for that. What she didn't realize was how many new friends and fun memories she would make through team events and countless construction sessions! She's joined again because she enjoys teaching and leading others, and would like to learn and contribute more. She LOVES movies, books, long walks, and photography!"
            />
            <Profile
              image="leads-2025-2026/nedel.jpg"
              memberName="Nedel Angelo Lenog Ellacer"
              role="Construction Manager"
              discipline="CIV2T7 + PEY"
              linkedin="https://www.linkedin.com/in/nedel-ellacer/"
              blurb="Nedel has always enjoyed creating and designing structures! His experience last year was filled with valuable insights and memories. This year, he looks forward to playing a more active role and contributing further to the team's success! He is also excited to deepen his understanding and technical skills required to manage the construction of this year's tower! He played the baritone saxophone, alto saxophone, and piano, and enjoys playing sports like soccer, badminton, basketball, and all kinds of sports."
            />
            <Profile
              image="leads-2025-2026/pakhi.jpg"
              memberName="Pakhi Gupta"
              role="Construction Specialist"
              discipline="CIV2T7 + PEY"
              linkedin="https://www.linkedin.com/in/pakhigupta29"
              blurb="Pakhi is looking to gain real-world engineering experience outside the classroom and is curious about how structural engineering ties into how buildings behave during earthquakes. She has been to school in three different countries, which has given her a broad perspective on life. Outside of academics, she is really passionate about music. She used to post covers on YouTube, and is currently a flute artist on Spotify. She has also taught herself to play the guitar and ukulele, and loves how music allows her to express herself creatively."
            />
          </div>
        </div>

        {/* Media, Social, Sponsorship */}
        <div className="row mb-5 mr-2 ml-2">
          <h2 className="big-font text-dark mb-5"> Media, Social, and Sponsorship </h2>
          <div className="row">
            <Profile
              image="leads-2025-2026/javeria.jpg"
              memberName="Javeria Rashid"
              role="Media Manager"
              discipline="CIV2T7 + PEY"
              linkedin="https://www.linkedin.com/in/javeria-rashid-58a494290/"
              blurb="Returning for her second year on the team, now stepping into a leadership role as Media Manager, Javeria is excited to support the team's success from both a communication and outreach perspective. She's passionate about using storytelling and visual media to capture the team's work, effort, and growth throughout the season. Looking forward to mentoring new members and helping build a strong team culture, she wants to continue learning about structural design and project teamwork while strengthening media and organizational skills. Committed to helping the team shine internally and externally through engaging content and consistent communication, she's inspired by the collaborative and hands-on environment from last year and eager to contribute even more this season. She loves graphic design and photography—rarely seen without her camera. She's a night owl but somehow always makes it to morning classes, loves exploring Toronto's architecture, and has a soft spot for bubble tea and could probably recommend a spot in every UofT building."
            />
            <Profile
              image="leads-2025-2026/rosa.jpeg"
              memberName="Rosa Khashayardoust"
              role="Media Manager"
              discipline="CIV2T9 + PEY"
              linkedin=""
              blurb="Rosa is interested in joining the seismic design team because it's a combination of her interests for structural design and scientific problem-solving, allowing her to apply engineering principles in a hands-on, visually impactful way. She's hoping to use her social media marketing experience to promote and shine light on this amazing club. She joined in her first year of undergrad in the hopes of building her skillset and working with experienced, like-minded people!! She enjoys playing basketball and video games in her free time."
            />
            <Profile
              image="leads-2025-2026/luana.jpg"
              memberName="Luana Zang"
              role="Social Director"
              discipline="CIV2T5 + PEY"
              linkedin="https://www.linkedin.com/in/luana-zang"
              blurb="Luana is interested in applying textbook knowledge into something hands-on, connecting with students from different disciplines, and the past few years have been awesome on the team so she's back. She performed at Disneyland before and slept for 26 hours one time."
            />
            <Profile
              image="leads-2025-2026/dana.jpeg"
              memberName="Dana Bou Saab"
              role="Social Director"
              discipline="CIV2T6 + PEY"
              linkedin=""
              blurb="Over the past few years, Dana has been involved with Seismic within a variety of roles. Previously, she's been a part of the DNA and construction subteams. She always liked Seismic's culture and how passionate all the members were about their roles. She enjoys event planning, coordinating with various parties, and working to expand Seismic's reach. This year she is joining Seismic to do just that. She's never had a chicken nugget."
            />
            <Profile
              image="leads-2025-2026/jason.jpeg"
              memberName="Jason (Jiasheng) Liu"
              role="Sponsorship Coordinator"
              discipline="CIV2T8"
              linkedin="https://www.linkedin.com/in/jiashengjasonliu"
              blurb="Jason is drawn to the Seismic Design Team for its more technical focus on structural engineering, the chance to make more friends, and to compete and win!! He was born on Dec 31st 2006, loves backpacking and hiking, and hopes to work in the energy sector."
            />
            <Profile
              image="leads-2025-2026/stanley.jpg"
              memberName="Stanley Pang"
              role="Digital Solutions Specialist"
              discipline="CS2T7"
              linkedin="https://www.linkedin.com/in/stanleypangg/"
              blurb="Stanley is eager to apply his digital solutions skills to real-world engineering challenges, moving beyond theory into practical, hands-on applications. He sees the Seismic Design Team as an opportunity to represent U of T in a prestigious competition while contributing to a community that pushes the boundaries of engineering innovation. Outside of academics, Stanley has reached Town Hall 13 in Clash of Clans, showing his dedication and strategic planning skills. He also has a quirky fun fact: his left thumb is double-jointed, which always makes for a great conversation starter."
            />
          </div>
        </div>

        {/* Team Director and Other Members */}
        <div className="row mb-5 mr-2 ml-2">
          <h2 className="big-font text-dark mb-5"> Team Director </h2>
          <div className="row">
            <Profile
              image="leads-2025-2026/sacha.jpg"
              memberName="Sacha Morin"
              role="Team Director"
              discipline="CIV2T5 + PEY"
              linkedin="https://www.linkedin.com/in/sachamorinn"
              blurb="Sacha is interested in joining the seismic design team to share all of the lessons he's learnt about leadership and to coach the next generation of the team. He likes to build things."
            />
          </div>
        </div>

      </div>
    );
  }
}